import { createAction } from 'redux-actions';

// Constants
export const TOGGLE_EXPERIMENTAL = 'experimental/TOGGLE';

// Reducer
const initialState = false;

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_EXPERIMENTAL:
      return !state;
    default:
      return state;
  }
};

// Action creators
export const toggleExperimental = createAction(TOGGLE_EXPERIMENTAL);

export const actions = {
  toggleExperimental,
};



// WEBPACK FOOTER //
// ./src/modules/experimental/Experimental.js